// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"53":"00c9dddd","156":"2e1366b3","399":"ed548a58","540":"ec1e2b82","988":"d45428fa"}[chunkId] + ".css";
};